import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { translationConstants } from "../../../constants";
import { allSharedComponents } from "../../../shared";

const ConfirmationModal = (props) => {
  const { t } = useTranslation();
  const { SpinnerContainer } = allSharedComponents;


  return (
    <div className="px-2 py-2">
      <div className="ViewHeader">
        <p className="viewUserPara">{props.title}</p>
      </div>
      <p className="horizentalLine" />

      <div className="my-3 mb-5">
        <p className="mb-2">{props.messageLine1}</p>
        <p className="mb-2">{props.messageLine2 && props.messageLine2}</p>
      </div>

      <div className="d-block d-sm-flex align-items-center justify-content-center my-2">
        <Row>
          <Col className="mt-1 d-flex justify-content-center">
            <Button
              className="approve-button mx-1 "
              type="button"
              onClick={() => {
                props.onSubmit();
              }}
            >
              {
                t(translationConstants.continue)
            }
            </Button>
          </Col>
          <Col className="mt-1 d-flex justify-content-center">
            <Button
              className="reject-button mx-1"
              type="button"
              onClick={() => {
                props.onCancel();
              }}
            >
              {t(translationConstants.cancel)}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ConfirmationModal;
